module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQwIiBoZWlnaHQ9IjgwIiB2aWV3Qm94PSIwIDAgMTQwIDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTQwIiBoZWlnaHQ9IjgwIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTE1IDIxLjg3OTlWMTQuNDQzMlYxNC40MzYyTDcwLjE0MjMgMzYuMjA0M0wyNS4wMTQyIDE0VjIxLjcxOEw2Mi4yNDk3IDQwLjAzODdMMjUgNTguMTEzMUwyNS4wMDcxIDY1LjU1NjhIMjUuMDE0Mkw2OS44NjQ4IDQzLjc4ODdMMTE1IDY2VjU4LjI4Mkw3Ny43NTc0IDM5Ljk1NDNMMTE1IDIxLjg3OTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-modal-close.svg
// module id = 5tjz
// module chunks = 1